import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import './assets/scss/style.scss'

/**
 * Bootstrap 4 - css framework
 */
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

/**
 * Displaying money values
 */
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

/**
 * Google Analytics
 */
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-143086520-1',
    router
})

/**
 * Used for anchor linking with smooth scrolling
 */
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

/**
 * Start up Vue App using #daylight-app div
 */
Vue.config.productionTip = false
// Vue.config.devtools = true;

new Vue({
    router,
    render: h => h(App)
}).$mount('#daylight-app')

